export default "__VITE_ASSET__Um$CAia1__"